import useLocalFeatureFlag from './useLocalFeatureFlag';

import { Features } from '@/shared/configs/features';

type FeatureFlag = keyof typeof Features;

export const useGetAllFeatureFlags = () => {
    const features = Object.keys(Features) as FeatureFlag[];

    features.forEach((key) => useLocalFeatureFlag(Features[key], false));
};
